// components/RingBenefitsExact.tsx
"use client";

import Image from "next/image";
import { Box } from "@mui/material";

export default function RingBenefitsExact({
    src = "/img/investments/operationalBenefits.svg", // <- replace with your path
    alt = "Operational Benefits",
    rounded = false,
    fit = "contain",
}) {
    return (
        <Box
            sx={{
                width: "100%",
                position: "relative",
                aspectRatio: "1444 / 472", // matches your design's proportions
                borderRadius: rounded ? "16px" : 0,
                overflow: rounded ? "hidden" : "visible",
            }}
        >
            <Image
                src={src}
                alt={alt}
                fill
                // sizes="(max-width: 600px) 100vw, (max-width: 1200px) 900px, 1100px"
                style={{ objectFit: fit }}
                priority
            />
        </Box>
    );
}
